<style lang="scss" scoped>
    .form .vview-formitem{
        margin-bottom:20px;
    }
    .border-bottom{
        border-bottom: 1px dashed #8cb9e8;
    }
</style>

<template>
    <div>
        <!-- amazon -->
        <div v-if="formType=='amazon'">
            <vForm :label-width="160" ref="amazonform" class="margin-15 clearfix">
                <vCol span="24">
					<vFormItem :label="$t('erp.channelbase.area', { defaultValue: '区域' })" :rules="required" prop="areaCode">
                        <vCheckbox v-for="(item,index) in alist" :key="index" :trueValue="index" v-model="formData.areaCode">{{item.label}}</vCheckbox>
					</vFormItem>
				</vCol>
                <div  v-for="val in formData.areaCode" :key="val" class="border-bottom">
                  <!-- <template v-if=""> -->
                       <vFormItem label="Country" :rules="required" prop="countryCode">
                            <div v-for="(json,index) in getCountryList(val)" :key="index">
                                <vCheckbox v-model="formData1[val].countryCode" :trueValue="json.value">{{json.title}}{{json.code}}</vCheckbox>
                                <vRadio :trueValue="index" :strict="false" :label="$t('erp.channelbase.default_main_account', { defaultValue: '默认为主账号' })" v-model="formData1[val].isMain"></vRadio>
                                <span v-if="formData1[val].isMain==index" class="color-error">{{$t('erp.channelbase.choose_one_main_account', { defaultValue: '只能选一个作为主账号，其他账号作为子账号。否则会多账号重复抓取数据' })}}</span>
                            </div>
                        </vFormItem>
                        <vFormItem label="Seller ID" :rules="required" prop="sellerId">
                            <vInput class="width-30per" v-model="formData1[val].sellerId"></vInput>
                        </vFormItem>
                        <!-- <vFormItem label="mwsAuthToken" :rules="required" prop="mwsAuthToken">
                            <vInput class="width-30per" v-model="formData1[val].mwsAuthToken"></vInput>
                        </vFormItem>
                        <vFormItem label="merchantToken" :rules="required" prop="merchantToken">
                            <vInput class="width-30per" v-model="formData1[val].merchantToken"></vInput>
                        </vFormItem> -->
                        <vFormItem :label="$t('erp.channelbase.start_data_type', { defaultValue: '开启同步的数据类型' })" >
                            <vCheckbox v-for="(item,index) in amazonProList" :trueValue="item.value" :key="index" v-model="formData1[val].isProduct" >{{item.title}}</vCheckbox>
                        </vFormItem>
                  <!-- </template> -->
                </div>
            </vForm>
        </div>
        <!-- vendors -->
        <div v-else-if="formType=='amazonvendor' || formType=='amazonvendords'">
            <vForm :label-width="160" ref="vendors" class="margin-15 clearfix">
                <vCol span="12">
					<vFormItem label="Country" :rules="required" prop="countryCode">
                        <vSelect v-model="vendorsData.countryCode">
                            <vOption value="US">US</vOption>
                            <vOption value="JP">JP</vOption>
                        </vSelect>
					</vFormItem>
                    <vFormItem label="Dropship" >
                        <vCheckbox v-model="vendorsData.dropship"></vCheckbox>
					</vFormItem>
                    <div >
                        <vFormItem label="SellingPartyId" :rules="required" prop="sellingPartyId" style="position:relative">
                            <Tooltip  max-width="500" style="width:100%" :content="this.$t('erp.channelbase.SellingPartyId', { defaultValue: '是否渠道支付运费' })" placement="top"> <Icon class="font-14" style="position: absolute;z-index: 11;right: 5px;top: 10px;" type="md-help-circle" />
                            <vInput v-model="vendorsData.sellingPartyId"></vInput>
                            </Tooltip>
                        </vFormItem>
                        <vFormItem label="IsLabeled" :rules="required" prop="paymentType">
                            <Tooltip  max-width="300" class="margin-right-10" :content="this.$t('erp.channelbase.IsLabeled', { defaultValue: '是否渠道支付运费' })" placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                            <vRadio trueValue="N" :strict="false" v-model="vendorsData.IsLabeled" class="margin-right-10" >{{$t("erp.global.no", { defaultValue: "否" })}}</vRadio>
                            <vRadio trueValue="Y" :strict="false" v-model="vendorsData.IsLabeled" >{{$t("erp.global.yes", { defaultValue: "是" })}}</vRadio>
                        </vFormItem>
                        <vFormItem :label="$t('erp.channelbase.start_data_type', { defaultValue: '开启同步的数据类型' })" >
                            <vCheckbox v-for="(item,index) in vendorsList" :trueValue="item.value" :key="index" v-model="vendorsData.new_flag1" >{{item.label}}</vCheckbox>
                        </vFormItem>
                    </div>
				</vCol>
                <vCol span="24">
                    <div  style="height:1px;border-bottom:1px solid #ddd"></div>
                </vCol>
                <vCol span="12">
                    <vFormItem label="PO" >
                        <vCheckbox v-model="vendorsData.po"></vCheckbox>
					</vFormItem>
                    <vFormItem :label="$t('erp.channelbase.start_data_type', { defaultValue: '开启同步的数据类型' })" >
                        <vCheckbox v-for="(item,index) in vendorspoList" :trueValue="item.value" :key="index" v-model="vendorsData.new_flag2" >{{item.label}}</vCheckbox>
                    </vFormItem>
                </vCol>
            </vForm>
        </div>
        <!-- others -->
        <div v-else>
            <compFormEdit class="margin-top-15 margin-right-15" ref="otherform" :formdata="getInterface" v-model="otherFormData" />
        </div>
    </div>
</template>

<script>
import {
    HttpGetTimeZoneByCountry
} from "@/service/managechannel/managechannel";
export default {
    props:['formType'],
    components:{
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data (){
        return {
            formData:{
                areaCode:[],
            },
            otherFormData:{
                new_flag:[],
                wayfairnew_flag:{
                    order:'N',
                    stock:'N',
                    outbound:'N',
                    product:'N',
                },
            },
            vendorsData:{
                IsLabeled:'N',
                new_flag1:[],
                new_flag2:[],
            },
            vendorsList:[
                {
                    value: 'order',
                    label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                }, {
                    value: 'stock',
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                },{
                    value: 'outbound',
                    label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                }
            ],
            vendorspoList:[
                {
                    value: 'order',
                    label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                },
            ],
            formData1:[
                {
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                },
                {
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                },{
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                }
            ],
            alist:[
				{label:this.$t('erp.channelbase.north_america', { defaultValue: '北美' }),areaCode:'North America'},
				{label:this.$t('erp.channelbase.europe', { defaultValue: '欧洲' }),areaCode:'Northwest Europe'},
				{label:this.$t('erp.channelbase.asia', { defaultValue: '亚洲' }),areaCode:'Asia'},
            ],

            amazondata:{
                // inventoryType:-1,
                sellerId:"",
                mwsAuthToken:"",
                merchantToken:"",
            },
            productList:[
                {title:this.$t('erp.channelbase.product', { defaultValue: "产品" }),value:"product"},
                {title:this.$t('erp.channelbase.order', { defaultValue: "订单" }),value:"order"},
                {title:this.$t('ucadm.notice.report', { defaultValue: "报表" }),value:"report"},
                {title:this.$t('erp.channelbase.caiwu', { defaultValue: "财务" }),value:"finance"},
                {title:this.$t('erp.channelbase.inbound', { defaultValue: "进库" }),value:"inbound"},
                {title:this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),value:"outbound"},
                {title:this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),value:"stock"},
            ],
            amazonProList: [
                {title:this.$t('erp.channelbase.product', { defaultValue: "产品" }),value:"product"},
                {title:this.$t('erp.channelbase.order', { defaultValue: "订单" }),value:"order"},
                {title:this.$t('ucadm.notice.report', { defaultValue: "报表" }),value:"report"},
                {title:this.$t('erp.channelbase.caiwu', { defaultValue: "财务" }),value:"finance"},
                {title:this.$t('erp.channelbase.inbound', { defaultValue: "进库" }),value:"inbound"},
                {title:this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),value:"outbound"},
                {title:this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),value:"stock"},
                {title:this.$t('erp.channelbase.get_afn_order', { defaultValue: "获取afn订单" }), value: "afnorder"}
            ],
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
            alists:[],
            styWidth : 210,
        }
    },
    watch: {
        formData1: {
            deep: true,
            handler (val) {
                console.log('formData1countryCode', val);
                let countryCodeList = [];
                val.map(item => {
                    item.countryCode.map(countryCode => {
                        countryCodeList.push(countryCode);
                    });
                });
                this.handleTimeZone(countryCodeList);
            }
        },
        "vendorsData.countryCode": {
            handler (val) {
                console.log('countryCode', val);
                this.handleTimeZone([val]);
            }
        },
        "otherFormData.countryCode": {
            handler (val) {
                console.log('countryCode', val);
                this.handleTimeZone([val]);
            }
        }

    },
    computed:{

        getInterface(){
            // console.log(this.formType)
            const htls  = this.formType;
            // console.log(htls)
			if (htls === 'ebay') return this.getEbay
            if (htls === 'walmart') return this.getWalmart
            if (htls === 'walmart_dsv') return this.getWalmartDsv
            // if (htls === 'amazonvendor') return this.getAmazonVendor
            // if (htls === 'amazonvendords') return this.getAmazonVendorDs
            if (htls === 'wayfair') return this.getWayfair
            if (htls === 'yamibuy') return this.getYamibuy
            if (htls === 'overstock') return this.getOverstock
            if (htls === 'allexpress') return this.getAllexpress
            if (htls === 'houzz') return this.getHouzz
            if (htls === 'newegg') return this.getNewegg
            if (htls === 'pricefalls') return this.getPricefalls
            if (htls === 'shopify') return this.getShopify
            if (htls === 'homedepot') return this.getHomeDepot
            if (htls === "lowes") return this.getHomeDepot;
            if (htls === 'hayneedle') return this.getHayneedle
            if (htls === 'houzz_dsv') return this.getHouzzDsv
            if (htls === 'sears') return this.getSears
            if (htls === 'manomano') return this.getManomano
            if (htls === 'eccang') return this.getEccang
            if (htls === 'costco') return this.getCostco
            if (htls === 'shipstation') return this.getShipstation
            return this.getOthersForm
        },
        getEbay(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "EbayToken",
                    key: "ebayToken",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                // {
				// 	label: "Ebay授权",
                //     key: "shipAddress",
                //     show:false,
                // },

			];
        },
        getWalmart(){
            // host默认值
            this.$set(this.otherFormData, 'host', 'https://marketplace.walmartapis.com')
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                // {
				// 	label: "consumerId",
                //     key: "consumerId",
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     },
                // },
                //  {
				// 	label: "privateEncodedStr",
                //     key: "privateEncodedStr",
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     },
                // },
                {
					label: "host",
                    key: "host",
                    required: true,
                    query: true,
                    props:{
                        readonly: true,
                        // value: 'https://marketplace.walmartapis.com'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "name",
                    key: "name",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "clientId",
                    key: "clientId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "clientSecret",
                    key: "clientSecret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                // {
				// 	label: "type",
                //     key: "type",
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     },
                // },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },
                    {
                        trueValue: "stock",
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                    },
                    {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getWalmartDsv(){
            this.$set(this.otherFormData, 'host', 'https://api-gateway.walmart.com')
            //this.$set(this.otherFormData, 'serviceName', 'Walmart Gateway API')
            //this.$set(this.otherFormData, 'correlationId', '1234hfvgtr')
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "clientId",
                    key: "clientId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "clientSecret",
                    key: "clientSecret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                /*{
					label: "correlationId",
                    key: "correlationId",
                    query: true,
                    formItem:{
                        disabled: true,
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "privateEncodedStr",
                    key: "privateEncodedStr",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },*/
                {
					label: "host",
                    key: "host",
                    query: true,
                    formItem:{
                        disabled: true,
                        labelWidth:this.styWidth,
                    },
                },
                // {
				// 	label: "shipNodeList",
                //     key: "shipNodeList",
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     },
                // },

                /*{
					label: "serviceName",
                    key: "serviceName",
                    query: true,
                    formItem:{
                        disabled: true,
                        labelWidth:this.styWidth,
                    },
                },*/
                // {
				// 	label: "type",
                //     key: "type",
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     },
                // },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    },{
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];},

        getAmazonVendor() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "ftpHost",
                    key: "ftpHost",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "privateKey",
                    key: "privateKey",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "downloadUser",
                    key: "downloadUser",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "uploadUser",
                    key: "uploadUser",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "ISAID",
                    key: "ISAID",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    },{
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
            ];
        },

        getAmazonVendorDs() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "ftpHost",
                    key: "ftpHost",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "privateKey",
                    key: "privateKey",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "downloadUser",
                    key: "downloadUser",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "uploadUser",
                    key: "uploadUser",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "ISAID",
                    key: "ISAID",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "IsLabeled",
                    key: "IsLabeled",
                    tag:'vSelect',
                    options:[
                        {value:'Y',labell:'Y'},
                        {value:'N',labell:'N'},
                    ],
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    },{
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
            ];
        },


        getWayfair(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
                    label: "packingSlip",
                    tag: 'vSelect',
                    key: "packingSlip",
                    options: [{
                        label: 'Y',
                        value: 'Y'
                    }, {
                        label: 'N',
                        value: 'N'
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: "Client Id",
                    key: "clientId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },{
                    label: "Client Secret",
                    key: "clientSecret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: "IntegrationAgent",
                    key: "wayfairIntegrationAgent",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
                },
                {
                    label: this.$t('erp.channelbase.getlabeltype', { defaultValue: "获取Label类型" }),
                    tag:"div",
                    required:false,
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    children: (h) => {
                        return <div>
                            <vCheckbox trueValue="Y" falseValue="N" v-model={this.otherFormData.wayfairnew_flag.SPlabel}>
                                <span class="font-12">SPlabel</span>
                            </vCheckbox>
                            <vCheckbox class="margin-left-10" trueValue="Y" falseValue="N" v-model={this.otherFormData.wayfairnew_flag.LTLlabel}>
                                <span class="font-12">LTLlabel</span>
                            </vCheckbox>
                        </div>
                    }
                },
                {
                    label: "Sandbox Client Id",
                    key: "sandboxClientId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    popper:this.$t('erp.channelbase.sandboxclientid', { defaultValue: "Sandbox Client Id" }),
                    required:false,
                },{
                    label: "Sandbox Client Secret",
                    key: "sandboxClientSecret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    popper:this.$t('erp.channelbase.sandboxclientsecret', { defaultValue: "Sandbox Client Secret" }),
                    required:false,
                },


                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    // key: "new_flag",
                    tag:"div",
                    required:false,
                    children: (h) => {
						return <div>
                            <div>{this.$t('erp.channelbase.order', { defaultValue: '订单' })}<Tooltip content={this.$t('erp.channelbase.wayfairorder', { defaultValue: "订单说明" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup v-model={this.otherFormData.wayfairnew_flag.order}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })}<Tooltip content={this.$t('erp.channelbase.wayfairstock', { defaultValue: "库存" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup v-model={this.otherFormData.wayfairnew_flag.stock}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('erp.channelbase.outbound', { defaultValue: '出库' })}<Tooltip content={this.$t('erp.channelbase.wayfairoutbound', { defaultValue: "出库" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup v-model={this.otherFormData.wayfairnew_flag.outbound}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('erp.channelbase.product', { defaultValue: '产品' })}<Tooltip content={this.$t('erp.channelbase.wayfairproduct', { defaultValue: "产品" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                        <RadioGroup v-model={this.otherFormData.wayfairnew_flag.product}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                        </div>
					},
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getYamibuy(){
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: " App Key",
                    key: "app_key",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: " App Secret",
                    key: "app_secret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

            ];
        },

        getOverstock(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "username",
                    key: "username",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "password",
                    key: "password",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "domain",
                    key: "domain",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [
                    {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },{
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },{
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: ' 库存' })
                    }, ],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getAllexpress(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "aliClientId",
                    key: "aliClientId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "aliAppsecret",
                    key: "aliAppsecret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "aliRefreshtoken",
                    key: "aliRefreshtoken",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    },{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getHouzz(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "houzzUsername",
                    key: "houzzUsername",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "houzzToken",
                    key: "houzzToken",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                }, {
                    label: "appname",
                    key: "appname",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    },{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getNewegg(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "Seller Id",
                    key: "neweggSellerId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "Secret Key",
                    key: "neweggSecretKey",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "Authorization",
                    key: "neweggAuthorization",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

                {
					label: this.$t('erp.channelbase.need_data_type', { defaultValue: "需同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    },{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getPricefalls(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "ftpAdrr",
                    key: "ftp_adrr",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "ftpPort",
                    key: "ftp_port",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "ftpUser",
                    key: "ftp_user",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "ftpPass",
                    key: "ftp_pass",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.need_data_type', { defaultValue: "需同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getShopify(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "apiKey",
                    key: "apiKey",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "password",
                    key: "password",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "hostname",
                    key: "hostname",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

                {
					label: this.$t('erp.channelbase.need_data_type', { defaultValue: "需同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    },{
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },{
                        trueValue: 'report',
                        label: this.$t('ucadm.notice.report', { defaultValue: '报表' })
                    }, {
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                    },{
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getHomeDepot(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "ftpHost",
                    key: "ftpHost",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "ftpUsername",
                    key: "ftpUsername",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "ftpPassword",
                    key: "ftpPassword",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "port",
                    key: "port",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "paymentId",
                    key: "paymentId",
                    required: false,
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    }, {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },{
                        trueValue: 'report',
                        label: this.$t('ucadm.notice.report', { defaultValue: '报表' })
                    }, {
                        trueValue: 'finance',
                        label: this.$t('erp.channelbase.caiwu', { defaultValue: '财务' })
                    },{
                        trueValue: 'inbound',
                        label: this.$t('erp.channelbase.inbound', { defaultValue: '进库' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },{
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: ' 库存' })
                    }, ],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getHayneedle(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "ftpHost",
                    key: "ftpHost",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "ftpUsername",
                    key: "ftpUsername",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "ftpPassword",
                    key: "ftpPassword",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "ftpAccount",
                    key: "ftpAccount",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "port",
                    key: "port",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "senderId",
                    key: "senderId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "receiverId",
                    key: "receiverId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    }, {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },{
                        trueValue: 'report',
                        label: this.$t('ucadm.notice.report', { defaultValue: '报表' })
                    }, {
                        trueValue: 'finance',
                        label: this.$t('erp.channelbase.caiwu', { defaultValue: '财务' })
                    },{
                        trueValue: 'inbound',
                        label: this.$t('erp.channelbase.inbound', { defaultValue: '进库' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },{
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: ' 库存' })
                    }, ],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getHouzzDsv(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "appname",
                    key: "appname",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "houzzUsername",
                    key: "houzzUsername",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "houzzToken",
                    key: "houzzToken",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    }, {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },{
                        trueValue: 'report',
                        label: this.$t('ucadm.notice.report', { defaultValue: '报表' })
                    }, {
                        trueValue: 'finance',
                        label: this.$t('erp.channelbase.caiwu', { defaultValue: '财务' })
                    },{
                        trueValue: 'inbound',
                        label: this.$t('erp.channelbase.inbound', { defaultValue: '进库' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },{
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: ' 库存' })
                    }, ],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getSears(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "searssellerId",
                    key: "searssellerId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "emailAdrr",
                    key: "emailAdrr",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: "searsToken",
                    key: "searsToken",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                // {
				// 	label: "flag",
                //     key: "flag",
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     },
                // },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    }, {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },{
                        trueValue: 'report',
                        label: this.$t('ucadm.notice.report', { defaultValue: '报表' })
                    }, {
                        trueValue: 'finance',
                        label: this.$t('erp.channelbase.caiwu', { defaultValue: '财务' })
                    },{
                        trueValue: 'inbound',
                        label: this.$t('erp.channelbase.inbound', { defaultValue: '进库' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },{
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: ' 库存' })
                    }, ],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getManomano() {
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "username",
                    key: "username",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "password",
                    key: "password",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [ {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getEccang(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "UserName",
                    key: "username",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "UserPass",
                    key: "userpass",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "ServiceToken",
                    key: "servicetoken",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "ApiUrl1",
                    key: "apiurl1",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "ApiUrl2",
                    key: "apiurl2",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
                    props:{
                        placeholder:'如果开启了库存同步，请填写'
                    }
				},
                {
					label: "ecWarehouses",
                    key: "ecWarehouses",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    popper:'若渠道指定仓库，则此参数留空不填，请前往基本设置->渠道仓库页面添加对应关系；若渠道不指定仓库，需要使用erp系统分仓，请将渠道的仓库code填入此处，若有多个请用/符号隔开',
                    required:false,
				},
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [ {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },{
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: ' 库存' })
                    },],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
			];
        },
        getCostco(){
            return [
                {
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "ftpHost",
                    key: "ftpHost",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "ftpUsername",
                    key: "ftpUsername",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "ftpPassword",
                    key: "ftpPassword",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "port",
                    key: "port",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "paymentId",
                    key: "paymentId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
                {
					label: "sellerParty",
                    key: "sellerParty",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "channelParty",
                    key: "channelParty",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "orderPath",
                    key: "orderPath",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "order997Path",
                    key: "order997Path",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "orderConfirmPath",
                    key: "orderConfirmPath",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "trackingPath",
                    key: "trackingPath",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "inventoryPath",
                    key: "inventoryPath",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "paymentPath",
                    key: "paymentPath",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "shippingFilePath",
                    key: "shippingFilePath",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "invoicePath",
                    key: "invoicePath",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [{
                        trueValue: 'product',
                        label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                    }, {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    },{
                        trueValue: 'report',
                        label: this.$t('ucadm.notice.report', { defaultValue: '报表' })
                    }, {
                        trueValue: 'finance',
                        label: this.$t('erp.channelbase.caiwu', { defaultValue: '财务' })
                    },{
                        trueValue: 'inbound',
                        label: this.$t('erp.channelbase.inbound', { defaultValue: '进库' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    },{
                        trueValue: 'stock',
                        label: this.$t('fbb.adjustment.list_inventory', { defaultValue: ' 库存' })
                    }, ],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
            ]
        },
        getShipstation(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "apiKey",
                    key: "apiKey",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				}, {
					label: "apiSecret",
                    key: "apiSecret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"vCheckbox",
                    required:false,
                    options: [ {
                        trueValue: 'order',
                        label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                    }, {
                        trueValue: 'outbound',
                        label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                    } ],
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },

			];
        },
        getOthersForm(){
            return [
				{
					label: "Country",
                    key: "countryCode",
                    tag:'vCheckbox',
                    props:{
                        label:'US (UNITED STATES)',
                        trueValue:'US'
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                    },
				},
			];
        },

    },
    methods:{
        async handleTimeZone (countryList) {
            let timeZoneList = [];
            for (let i = 0; i < countryList.length; i ++) {
                await HttpGetTimeZoneByCountry({
                    type: this.formType,
                    country: countryList[i],
                }).then(res => {
                    console.log("timezone", res);
                    if (res.data) {
                        // if (!res.data.timeZone) return;
                        timeZoneList.push(res.data.timeZone);
                    }
                }, err => {
                    this.$VMessage.error(err.message);
                });
            }
            // await countryList.map(async code => {
            //     await HttpGetTimeZoneByCountry({
            //         type: this.formType,
            //         country: code,
            //     }).then(res => {
            //         console.log("timezone", res);
            //         if (res.data) {
            //             timeZoneList.push(res.data.country);
            //         }
            //     }, err => {
            //         this.$VMessage.error(err.message);
            //     });
            // });
            console.log(timeZoneList);
            let timeZoneSet = new Set(timeZoneList);
            let timeZone = "";
            if (timeZoneSet.size == 1) {
                timeZone = Array.from(timeZoneSet)[0];
            }
            console.log(timeZone);
            this.$emit('on-timezone', timeZone);
        },
        getCountryList(val){
            const list= [
                [
                    {value:'CA',title:"Canada",code:"(amazon.ca)"},
                    {value:'MX',title:"Mexico",code:"(amazon.mx)"},
                    {value:'US',title:"UNITED STATES",code:"(amazon.com)"},
                ],
                [
                    {value:'DE',title:"Germany",code:"(amazon.de)"},
                    {value:'ES',title:"Spain",code:"(amazon.es)"},
                    {value:'IT',title:"Italy",code:"(amazon.it)"},
                    {value:'FR',title:"FRANCE",code:"(amazon.fr)"},
                    {value:'GB',title:"UNITED KINGDOM",code:"(amazon.uk)"},
                    {value:'AE',title:"The United Arab Emirates",code:"(amazon.ae)"},
                    {value:'NL',title:"The Netherlands",code:"(amazon.nl)"},
                    {value:'SE',title:"Sweden",code:"(amazon.se)"},
                    {value:'PL',title:"Poland",code:"(amazon.pl)"},
                    {value:'BE',title:"Belgium",code:"(amazon.bel)"},
                    {value:'TR',title:"Turkey",code:"(amazon.com.tr)"},
                ],
                [
                    {value:'AU',title:"AUSTRALIA ",code:"(amazon.au)"},
                    {value:'JP',title:"JAPAN",code:"(amazon.jp)"},
                ]
            ]
            return list[val];
        },
        async validate(){
            if(this.formType=='amazon'){
                // console.log(123123)
                const bool1 = await this.$refs['amazonform'].validate();
                // console.log(bool1)
                if (!bool1) {
                    this.$VMessage.warning(this.$t('global.form.require', { defaultValue: "请填写必填项" }));
                }
                return bool1;
            }else if(this.formType=='amazonvendor' || this.formType=='amazonvendords'){
                let bool2 = true;
                if(!this.vendorsData.countryCode){
                    bool2 = false
                    this.$VMessage.warning(this.$t('global.form.require', { defaultValue: "请填写必填项" }));
                    return bool2;
                }
                if(!this.vendorsData.dropship && !this.vendorsData.po){
                    bool2 = false
                    this.$VMessage.warning(this.$t('erp.managechannel.dropshipop', { defaultValue: "Dropship或者PO请勾选其一" }));
                    return bool2;
                }
                if(this.vendorsData.dropship){
                    if(!this.vendorsData.sellingPartyId){
                        bool2 = false
                        this.$VMessage.warning(this.$t('global.form.require', { defaultValue: "请填写必填项" }));
                        return bool2;
                    }
                }
                return bool2;

            }else{
                const bool = await this.$refs['otherform'].validate();
                // console.log(bool)
                if (!bool) {
                    this.$VMessage.warning(this.$t('global.form.require', { defaultValue: "请填写必填项" }));
                }
                return bool;
            }
		},
    }

}
</script>
